module.exports = __webpack_public_path__ + "b9134cc94709f09b998452f2f88a4905.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./www/assets/img/no-image.jpg
 ** module id = 411
 ** module chunks = 0
 **/